<template>
    <img v-if="show === 'profile'" v-bind:src="member.image_url" v-on:error="fallbackToGravatar">
    <img v-else-if="show === 'gravatar' && member.gravatar_hash" v-bind:src="gravatarUrl" v-on:error="fallbackToInitials">
    <div v-else class="avatar-initials c-muted-dim-bg c-bright">
        <span>{{ member.initials }}</span>
    </div>
</template>
<script>
import { getGravatarUrlFromHash } from '../helpers';

export default {
    props: {
        member: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            show: this.member.image_url ? 'profile' : 'gravatar',
        }
    },
    computed: {
        gravatarUrl() {
            return getGravatarUrlFromHash(this.member.gravatar_hash);
        },
    },
    methods: {
        fallbackToGravatar() {
            this.show = 'gravatar';
        },
        fallbackToInitials() {
            this.show = 'initials';
        },
    }
}
</script>
